"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetvigatorItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
 * @Author: tenlau
 * @Date: 2021-02-04 15:24:26
 * @Last Modified by: tenlau
 * @Last Modified time: 2021-04-14 16:11:33
 */
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var NetvigatorItem = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
      link = props.link,
      index = props.index,
      record = props.record,
      className = props.className,
      restProps = __rest(props, ["children", "link", "index", "record", "className"]); // const rellocateBlock = () => {
  //
  //   //testing function to scroll to target block
  //     console.log('i click loading',link);
  //   if(link != ''){
  //     var d = document.getElementById(link) as HTMLElement;
  //
  //     try{
  //     var blockLocation = d.offsetTop;
  //     window.scrollTo(0, blockLocation);
  //
  //     }catch{
  //     }
  //   }
  //
  // }


  return /*#__PURE__*/_react["default"].createElement("span", __assign({
    ref: ref,
    // onClick={rellocateBlock}
    className: (0, _classnames["default"])('tci-nvritem', {}, className)
  }, restProps), children);
});
exports.NetvigatorItem = NetvigatorItem;
NetvigatorItem.displayName = 'TCINetvigatorItem';